//@flow

// Vendors
import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Components
import { PrivateRoute } from '../components';

// Pages
import getPages from '../pages';
import PAGE_TYPES from '../pages/pageTypes';

const {
  DashboardPage,
  AccountPage,
  AgencyPage,
  HistoryPage,
  NoMatchPage,
  EmployeePage,
  EmployeeAgencyPage,
} = getPages(PAGE_TYPES.AUTH);

const RoutesAuth = () => (
  <Switch>
    <PrivateRoute exact path="/dashboard" component={DashboardPage} />
    <PrivateRoute path="/account" component={AccountPage} />
    {/* for "/empDashboard" and possible for "empDashboard/:agencySlug?" */}
    <PrivateRoute exact path="/employee" component={EmployeePage} />
    <PrivateRoute
      exact
      path="/employee/:agencySlug?"
      component={EmployeeAgencyPage}
    />
    <PrivateRoute path="/history/:type?" component={HistoryPage} />
    <PrivateRoute path="/agency/:agencySlug?" component={AgencyPage} />
    <Route component={NoMatchPage} />
  </Switch>
);

export default RoutesAuth;
